import { FC } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { makeSxStyles } from "ui";

const LoadingPage: FC = () => {
  const styles = useStyles();

  return (
    <Grid sx={styles.container}>
      <CircularProgress size={64} />
    </Grid>
  );
};

const useStyles = makeSxStyles(() => ({
  container: {
    width: "100wv",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    background:
      "radial-gradient( ellipse farthest-corner at top right, rgba(0, 128, 184, 0.30) 10%, rgba(138, 206, 255, 0) 80%)",
    filter: "grayscale(30%)",
  },
}));

export default LoadingPage;
